import isCssColorVariableExist from './is-css-color-variable-exist';
import isCustomColorUsedOnThePage from './is-custom-color-used-on-the-page';
import isCustomColorUsed from './is-custom-color-used';

export default {
  isCssColorVariableExist,
  isCustomColorUsedOnThePage,
  isCustomColorUsed,
};
